import { put, select, take, takeEvery } from 'redux-saga/effects';
import has from 'lodash/has';

import chatConsts from '../../chatConnection/constants';
import { actions as reqChannelParticipants } from '../reqChannelParticipants';
import { activeChannelIdSelector } from '../../chatConnection/selectors';
import { consts as reqChannel } from '../reqChannel';

function* updateChatWorker(action) {
  const activeChannelId = yield select(activeChannelIdSelector);
  const channelId = parseInt(action.payload.channelId, 10);

  yield put({
    type: reqChannel.SEND,
    payload: { id: channelId },
  });

  const updatedChannel = yield take(reqChannel.SUCCEED);

  yield put({
    type: chatConsts.UPDATE_CHANNEL,
    payload: updatedChannel.payload,
  });

  if (has(updatedChannel, 'payload.contextUser')) {
    yield put({
      type: chatConsts.UPDATE_CONTEXT_CHANNEL,
      payload: updatedChannel.payload,
      activeChannelId: channelId,
    });
  }

  if (activeChannelId === channelId) {
    yield put(reqChannelParticipants.send({ id: activeChannelId }));
  }
}

export default function* updateChatSaga() {
  yield takeEvery(chatConsts.UPDATE_CHAT, updateChatWorker);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/updateChatSaga.js